import type { UnboxingSettings } from "@/context/CampaignBuilderContext";

/** Builds the unboxing headline from token toggle state — mirrors prototype's updateUbHeadlineFromToggles. */
export function buildUbHeadline(s: UnboxingSettings): string {
  if (s.tokenSignature) return "@Signature sent you a choice of gifts...";
  const parts: string[] = [];
  if (s.tokenFirstName) parts.push("@SenderFirstName");
  if (s.tokenLastName) parts.push("@SenderLastName");
  let prefix = parts.join(" ");
  if (s.tokenCompany && prefix) prefix += " from @SenderCompany";
  else if (s.tokenCompany) prefix = "@SenderCompany";
  return `${prefix} sent you a choice of gifts...`;
}
